// import { persistStore } from "redux-persist";
// import reducer from "./mainReducers";
// import { configureStore } from "@reduxjs/toolkit";
// import { thunk } from 'redux-thunk';  // Correct import

// // ==============================|| REDUX - MAIN STORE ||============================== //

// const store = configureStore({
//     reducer, 
//     middleware: (getDefaultMiddleware) => getDefaultMiddleware({
//       serializableCheck: false,  // Disable the serializable check if you need to
//   }).concat(thunk),  // Add redux-thunk
//   });

// export { store };
// export const persistor = persistStore(store);

import { persistStore } from "redux-persist";
import reducer from "./mainReducers";
import { configureStore } from "@reduxjs/toolkit";

// ==============================|| REDUX - MAIN STORE ||============================== //

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable the serializable check if needed
    }),
});

export { store };
export const persistor = persistStore(store);
